import { createRouter, createWebHistory } from "vue-router"
const routes = [
    {
        path: "/",
        component: () => import("@/views/Login.vue"),
    },
    // 登录
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/Login.vue"),
    },
    //隐私政策
    {
        path: "/privacy",
        name: "privacy",
        component: () => import("@/views/privacy.vue"),
    },
     //VIP会员协议
     {
        path: "/vipText",
        name: "vipText",
        component: () => import("@/views/vip.vue"),
    },
    //用户协议
    {
        path: "/agreement",
        name: "agreement",
        component: () => import("@/views/agreement.vue"),
    },
    // 管理员首页
    {
        label: "管理员首页",
        path: "/admin",
        name: "admin",
        component: () => import("@/layout/Adminhome.vue"),
        children: [
            {
                label: "首页",
                path: "home",
                name: "home",
                component: () => import("@/views/home/home.vue")
            },
        ]
    },
    //讲书详情
    {
        label: "讲书详情",
        path: "/hearDetail",
        name: "hearDetail",
        component: () => import("@/views/book/hearDetail.vue"),
    },
    // 图书管理
    {
        label: "图书管理",
        path: "/book",
        name: "book",
        component: () => import("@/layout/Adminhome.vue"),
        children: [
            {
                label: "分类管理",
                path: "category",
                name: "category",
                component: () => import("@/views/book/category.vue")
            },
            {
                label: "图书管理",
                path: "bookManage",
                name: "bookManage",
                component: () => import("@/views/book/book.vue")
            },
            {
                label: "借阅列表",
                path: "borrowManager",
                name: "borrowManager",
                component: () => import("@/views/book/borrowManager.vue")
            },
            {
                label: "轮播图管理",
                path: "banner",
                name: "banner",
                component: () => import("@/views/book/swiperManager.vue")
            },
            {
                label: "讲书管理",
                path: "bookHear",
                name: "bookHear",
                component: () => import("@/views/book/bookHear.vue")
            },
            {
                label: "听书记录",
                path: "hearManager",
                name: "hearManager",
                component: () => import("@/views/book/hearManager.vue")
            },
        ]
    },
    //评论
    {
        label: "评论管理",
        path: "/comment",
        name: "comment",
        component: () => import("@/layout/Adminhome.vue"),
        children: [
            {
                label: "书籍评论",
                path: "bookComment",
                name: "bookComment",
                component: () => import("@/views/comment/bookComment.vue")
            },
            {
                label: "意见反馈",
                path: "advice",
                name: "advice",
                component: () => import("@/views/comment/advice.vue")
            }
        ]
    },
    {
        label: "用户管理",
        path: "/user",
        name: "user",
        component: () => import("@/layout/Adminhome.vue"),
        children: [
            {
                label: "用户列表",
                path: "userManager",
                name: "userManager",
                component: () => import("@/views/user/userManager.vue")
            },
            {
                label: "账单列表",
                path: "billManager",
                name: "billManager",
                component: () => import("@/views/user/billManager.vue")
            }
        ]
    },
    {
        label: "会员管理",
        path: "/vipManager",
        name: "vipManager",
        component: () => import("@/layout/Adminhome.vue"),
        children: [
            {
                label: "会员卡管理",
                path: "vipCardManager",
                name: "vipCardManager",
                component: () => import("@/views/vipManager/vipCardManager.vue")
            },
            {
                label: "积分记录",
                path: "pointsHistory",
                name: "pointsHistory",
                component: () => import("@/views/vipManager/pointsHistory.vue")
            }
        ]
    },
    {
        label: "设置",
        path: "/set",
        name: "set",
        component: () => import("@/layout/Adminhome.vue"),
        children: [
            {
                label: "敏感词管理",
                path: "Sensitive",
                name: "Sensitive",
                component: () => import("@/views/set/sensitive.vue")
            },
            {
                label: "批量添加敏感词",
                path: "add",
                name: "add",
                component: () => import("@/views/set/add.vue")
            },
            {
                label: "日志管理",
                path: "log",
                name: "log",
                component: () => import("@/views/set/logHistory.vue")
            },
            {
                label: "app版本管理",
                path: "version",
                name: "version",
                component: () => import("@/views/set/version.vue")
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
